'use client';
import React from 'react';
import { GoogleTagManager } from '@next/third-parties/google';
import useEnvVariable from '@/hooks/useEnvVariable';
import useCspNonce from '@/hooks/useCspNonce';

export default function GoogleTagManagerScript({
  dataLayer,
}: Readonly<{ dataLayer?: Record<string, any> }>) {
  const { gtmId, gtmPreviewId, gtmAuthKey, gtmServerUrl } = useEnvVariable();
  const nonce = useCspNonce();
  return (
    <GoogleTagManager
      gtmId={gtmId}
      preview={gtmPreviewId}
      auth={gtmAuthKey}
      dataLayer={dataLayer}
      gtmScriptUrl={gtmServerUrl}
      nonce={nonce}
    />
  );
}
